enum ROLES {
  ROLE_INT_BILLING = 1,
  ROLE_INT_ACTIVITIES = 2,
  ROLE_INT_ADMIN_CLIENT = 3,
  ROLE_INT_ADMIN_INTERNAL = 4,
  ROLE_INT_SUPER_ADMIN = 5,
  ROLE_CLI_ACTIVITIES = 6,
  ROLE_CLI_BILLING = 7,
  ROLE_CLI_ADMIN = 8,
  ROLE_INT_SUPPORT_N1 = 9,
  ROLE_CLI_DEMANDS = 10,
}

export default ROLES
